import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-tag" }

import { ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import debounce from "lodash-es/debounce";

import type { TagType, TagPayloadType } from "@/common/types/tag";

import { baseInput, baseTextEditor } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'form-tag',
  props: {
    data: {},
    isPatch: { type: Boolean }
  },
  emits: ["update:data", "salve:data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const DEFAULT_DATA = {
  name: "",
  slug: "",
  description: "",
};

const payload = ref<TagPayloadType>({ ...DEFAULT_DATA });

function update(key: keyof typeof payload.value) {
  if (props.isPatch) {
    emit("update:data", { [key]: payload.value[key] });
    return;
  }

  emit("update:data", payload.value);
}

function resumeData() {
  if (!props.data) return;

  const { name, slug, description } = props.data;

  payload.value = {
    ...payload.value,
    name,
    slug,
    description,
  };
}

function maskCode(data: string) {
  return data?.replaceAll(" ", "-")?.toUpperCase();
}

function maskSlug(data: string) {
  return data?.replaceAll(" ", "-")?.toLowerCase();
}

const debouceUpdate = debounce(update, 300);

watchEffect(() => {
  resumeData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(baseInput), {
      modelValue: payload.value.name,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((payload.value.name) = $event)),
        _cache[1] || (_cache[1] = ($event: any) => (_unref(debouceUpdate)('name')))
      ],
      value: payload.value.name,
      placeholder: _unref(t)('tag.placeholders.name'),
      required: ""
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("tag.labels.name")) + " * ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value", "placeholder"]),
    _createVNode(_unref(baseInput), {
      modelValue: payload.value.slug,
      "onUpdate:modelValue": [
        _cache[2] || (_cache[2] = ($event: any) => ((payload.value.slug) = $event)),
        _cache[3] || (_cache[3] = ($event: any) => (_unref(debouceUpdate)('slug')))
      ],
      value: payload.value.slug,
      placeholder: _unref(t)('tag.placeholders.slug'),
      mask: maskSlug
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("tag.labels.slug")), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value", "placeholder"]),
    _createVNode(_unref(baseTextEditor), {
      modelValue: payload.value.description,
      "onUpdate:modelValue": [
        _cache[4] || (_cache[4] = ($event: any) => ((payload.value.description) = $event)),
        _cache[5] || (_cache[5] = ($event: any) => (_unref(debouceUpdate)('description')))
      ]
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("tag.labels.description")), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})